[data-karsilastirma-onerisi] {
  min-width: 0;
  animation: karsilastirma-giris 180ms ease-out;
}
[data-karsilastirma-simdiki] {
  display: none;
}
@media (min-height: 560px) {
  [data-karsilastirma-onerisi][data-karsilastirma-sabit='true'] {
    position: fixed !important;
    bottom: 20px;
    left: 50%;
    translate: -50% 0;
    z-index: 34;
    width: min(1180px, calc(100% - 48px));
    box-shadow: 0 6px 28px #00000012;
    display: grid !important;
    grid-template-columns: minmax(220px, 1.2fr) minmax(160px, 1fr) minmax(160px, 1fr) auto;
    align-items: center !important;
    gap: 20px !important;
  }
  [data-karsilastirma-sabit='true'] [data-karsilastirma-simdiki] {
    display: flex;
  }
  [data-karsilastirma-sabit='true'] [data-karsilastirma-mobil-kapat] {
    display: none;
  }
  [data-ilan-detay-alani]:has([data-karsilastirma-bileseni][data-sabit-oneri='true']) {
    padding-bottom: calc(var(--karsilastirma-serit-yuksekligi, 112px) + 40px) !important;
  }
  html:not(.pazar-klavye-acik) body:has([data-karsilastirma-katmani]) [data-bildirim] {
    bottom: calc(var(--karsilastirma-serit-yuksekligi, 112px) + 32px) !important;
  }
}
@keyframes karsilastirma-giris {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.pazar-pencere[open][data-alttan]:has([data-karsilastirma-alt-penceresi]) {
  animation: karsilastirma-alt-pencere 220ms ease-out;
}
@keyframes karsilastirma-alt-pencere {
  from {
    opacity: 0;
    transform: translateY(32px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  [data-karsilastirma-onerisi],
  .pazar-pencere[open]:has([data-karsilastirma-alt-penceresi]) {
    animation: none;
  }
}
